module.exports = __webpack_public_path__ + "static/img/img_3.07ff534.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_3.png
// module id = JlR2
// module chunks = 169